import React, { useState } from "react";
import cars from "../data/Cars";
import { Helmet } from "react-helmet";
// icons
import seatsIcon from "../assets/otherimages/seats.png";
import transmissionIcon from "../assets/otherimages/transmission.png";
import doorsIcon from "../assets/otherimages/doors.png";

const OurCars = () => {
  const [showAll, setShowAll] = useState(false);
  const visibleCars = showAll ? cars : cars.slice(0, 4);

  // WhatsApp number
  const whatsappNumber = "971554421108";

  const handleEnquiry = (car) => {
    const message = `Hello Blue Diamond Rent a Car, I would like to enquire about renting the following car:
Car: ${car.name}
Seats: ${car.seats}
Please provide me with more details.`;

    const url = `https://api.whatsapp.com/send?phone=${whatsappNumber}&text=${encodeURIComponent(
      message
    )}`;
    window.open(url, "_blank");
  };

  const handleShowLess = () => {
    setShowAll(false);
    // Smooth scroll back to "Our Cars" title
    const section = document.getElementById("cars");
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (

    <>
     <Helmet>
        <title>Our Cars | Blue Diamond Rent Car Dubai</title>
        <meta
          name="description"
          content="Browse our collection of luxury and economy rental cars in Dubai. Affordable, clean, and ready to drive today!"
        />
        <link rel="canonical" href="https://bluediamondrentcar.com/cars" />
      </Helmet>
    <section id="cars" className="py-16 px-4 sm:px-8 lg:px-20 bg-white">
      <div className="container mx-auto text-center">
        {/* Title */}
        <h2 className="text-2xl md:text-3xl font-bold text-[#0B2F6B]">
          OUR CARS
        </h2>
        <p className="text-[#123775] mb-10 mt-2 text-lg md:text-xl">
          Most popular cars rental deals
        </p>

        {/* Cars Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 md:gap-8">
          {visibleCars.map((car, index) => (
            <div
              key={index}
              className="border-t-8 border-l-8 shadow-lg border-[#123775] border-r-0 border-b-0 rounded-[35px] p-1 transform transition-transform duration-300 hover:scale-105 hover:shadow-2xl"
            >
              <div className="bg-white rounded-2xl p-6 flex flex-col items-center h-full">
                {/* Car Image */}
                <img
                  src={car.image}
                  alt={car.name}
                  className="w-full h-40 object-contain mb-4 transition-transform duration-300 group-hover:scale-110"
                  loading="lazy"
                />

                {/* Car Name */}
                <h3 className="text-lg font-semibold text-gray-900">
                  {car.name}
                </h3>
                <p className="text-sm text-gray-500 mb-6">(or similar)</p>

                {/* Car Details */}
                <div className="flex justify-between w-full mb-6">
                  {/* Seats */}
                  <div className="flex flex-col items-center">
                    <span className="text-[0.7rem] font-semibold text-[#0B2F6B]">
                      SEATS
                    </span>
                    <div className="w-12 h-12 bg-blue-50 rounded-full flex items-center justify-center mb-1">
                      <img src={seatsIcon} alt="Seats" className="h-6" />
                    </div>
                    <span className="text-xs text-[#0B2F6B]">{car.seats}</span>
                  </div>

                  {/* Transmission */}
                  <div className="flex flex-col items-center">
                    <span className="text-[0.7rem] font-semibold text-[#0B2F6B]">
                      TRANSMISSION
                    </span>
                    <div className="w-12 h-12 bg-blue-50 rounded-full flex items-center justify-center mb-1">
                      <img
                        src={transmissionIcon}
                        alt="Transmission"
                        className="h-6"
                      />
                    </div>
                    <span className="text-xs text-[#0B2F6B] uppercase">
                      {car.transmission}
                    </span>
                  </div>

                  {/* Doors */}
                  <div className="flex flex-col items-center">
                    <span className="text-[0.7rem] font-semibold text-[#0B2F6B]">
                      DOORS
                    </span>
                    <div className="w-12 h-12 bg-blue-50 rounded-full flex items-center justify-center mb-1">
                      <img src={doorsIcon} alt="Doors" className="h-6" />
                    </div>
                    <span className="text-xs text-[#0B2F6B]">{car.doors}</span>
                  </div>
                </div>

                {/* Rent Button */}
                <button
                  onClick={() => handleEnquiry(car)}
                  className="bg-[#123775] text-white w-full py-3 rounded-[10px] font-semibold flex items-center justify-center gap-2 hover:opacity-90 hover:scale-[1.02] transition-all duration-300 mt-auto"
                >
                  Rent Now <span aria-hidden>→</span>
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Show All / Show Less Button */}
        <div className="mt-10">
          {!showAll ? (
            <button
              onClick={() => setShowAll(true)}
              className="px-6 py-3 border border-gray-400 rounded-lg font-medium text-gray-700 hover:bg-gray-100 hover:scale-105 transition-all duration-300 inline-flex items-center gap-2"
            >
              Show all vehicles <span aria-hidden>→</span>
            </button>
          ) : (
            <button
              onClick={handleShowLess}
              className="px-6 py-3 border border-gray-400 rounded-lg font-medium text-gray-700 hover:bg-gray-100 hover:scale-105 transition-all duration-300 inline-flex items-center gap-2"
            >
              Show less <span aria-hidden>↑</span>
            </button>
          )}
        </div>
      </div>
    </section>
    </>
    
  );
};

export default OurCars;
